var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-md-3 col-6 mt-2 wrapHighlight"},[_c('Multiselect',{attrs:{"options":_vm.filterData.dealer.map(function (x) { return x.code; }),"custom-label":function (opt) { return _vm.filterData.dealer.find(function (x) { return x.code == opt; }).name; },"placeholder":"Select 1 Dealer","allow-empty":false},model:{value:(_vm.filter.dealer),callback:function ($$v) {_vm.$set(_vm.filter, "dealer", $$v)},expression:"filter.dealer"}})],1),_c('div',{staticClass:"col-md-2 col-3 mt-2"},[_c('Multiselect',{attrs:{"options":_vm.filterData.trendType,"allow-empty":false},model:{value:(_vm.showType),callback:function ($$v) {_vm.showType=$$v},expression:"showType"}})],1),_c('div',{staticClass:"col-md-2 col-3 mt-2"},[_c('button',{staticClass:"btn w-100 btn-secondary",staticStyle:{"height":"40px"},on:{"click":_vm.downloadExcel}},[_vm._v("\n\t\t\t\tDownload CSV\n\t\t\t")])])]),(_vm.dataTable)?_c('div',{staticClass:"mt-4"},[(_vm.showType == 'by Table')?_c('div',{staticStyle:{"width":"100%","overflow-x":"scroll"}},[_c('table',{staticClass:"table text-center table-bordered",attrs:{"id":"table"}},[_c('thead',{staticStyle:{"border-bottom":"1px solid grey"}},[_c('tr',[_c('th',{staticClass:"freezeCol",staticStyle:{"margin-top":"0.5px"}}),_vm._l((_vm.dataTable),function(month){return [_c('th',{attrs:{"colspan":"3"}},[_vm._v(_vm._s(month.bulan))])]})],2),_c('tr',[_c('th',{staticClass:"freezeCol",staticStyle:{"height":"54px"}},[_vm._v("Ring")]),_vm._l((_vm.dataTable),function(month){return [_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("Sales")]),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("% Contribution")]),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("Growth")])]})],2)]),_vm._l((Object.keys(_vm.dataTable[0])),function(object){return _c('tbody',{key:object},[(
							object != 'bulan' &&
								!(
									object.includes('Sales') ||
									object.includes('Percentage')
								)
						)?[_c('tr',[_c('td',{staticClass:"h6 freezeCol"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.capitalize(object.toLowerCase()))+"\n\t\t\t\t\t\t\t")]),_vm._l((_vm.dataTable),function(data,index){return [_c('td',{key:object + data.bulan + index},[_c('span',{staticClass:"h6"},[_vm._v(_vm._s(_vm.numberWithCommas(data[object].sales)))])]),_c('td',{key:object +
											data.bulan +
											index +
											'percent'},[_c('span',{staticClass:"ml-2",class:{
											'text-red':
												parseFloat(
													data[object].percent
												) < 0,
											'text-green':
												parseFloat(
													data[object].percent
												) > 0,
										}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(parseFloat(
												data[object].percent
											) > 0
												? "+"
												: "-")+"\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(Math.abs(
												parseFloat(
													data[object].percent
												)
											))+"\n\t\t\t\t\t\t\t\t\t\t%\n\t\t\t\t\t\t\t\t\t")])]),_c('td',{key:object +
											data.bulan +
											index +
											'growth'},[_c('span',{staticClass:"ml-2",class:{
											'text-red':
												parseFloat(
													data[object].growth
												) < 0,
											'text-green':
												parseFloat(
													data[object].growth
												) > 0,
										}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(parseFloat(
												data[object].growth
											) > 0
												? "+"
												: "-")+"\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(Math.abs(
												parseFloat(
													data[object].growth
												)
											))+"\n\t\t\t\t\t\t\t\t\t\t%\n\t\t\t\t\t\t\t\t\t")])])]})],2)]:_vm._e()],2)}),(_vm.salesRef)?_c('tbody',[_c('tr',[_c('td',{staticClass:"h6 freezeCol"},[_vm._v("Total")]),_vm._l((_vm.salesRef),function(total){return [_c('td',[_vm._v(_vm._s(total.sales))]),_c('td',{class:{
									'text-red':
										parseFloat(
											total.percent
										) < 0,
									'text-green':
										parseFloat(
											total.percent
										) > 0,
								}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(parseFloat(total.percent) > 0
										? "+"
										: "-")+"\n\t\t\t\t\t\t\t\t"+_vm._s(Math.abs(parseFloat(total.percent)))+" %\n\t\t\t\t\t\t\t")]),_c('td',{class:{
									'text-red':
										parseFloat(
											total.growth
										) < 0,
									'text-green':
										parseFloat(
											total.growth
										) > 0,
								}})]})],2)]):_vm._e()],2)]):_c('div',[_c('TrendSalesLineChart',{attrs:{"data":_vm.formattedData}})],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-5 col-12 mt-2"},[_c('h3',[_vm._v("Territory Trend Sales")]),_c('h6',[_vm._v("Choose 1 Dealer To Use This Feature")])])}]

export { render, staticRenderFns }